import Vue from 'vue'
import Router from 'vue-router'
import auth from "../utils/auth";
import Utils from "@/utils/util"
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        title: '首页',
      },
      component: () => import("@/view/index/index")
    },
    {
      path: '/yhxy',
      name: 'yhxy',
      meta: {
        title: '用户协议',
      },
      component: () => import("@/view/index/yhxy")
    },
    {
      path: '/gykf',
      name: 'gykf',
      meta: {
        title: '用户协议',
      },
      component: () => import("@/view/index/gykf")
    },
    {
      path: '/course/list',
      name: 'courseList',
      meta: {
        title: '课程列表',
      },
      component: () => import("@/view/index/course/list")
    },
    {
      path: '/course/detail',
      name: 'courseDetail',
      meta: {
        title: '课程详情',
      },
      component: () => import("@/view/index/course/detail")
    },
    {
      path: '/order/found',
      name: 'orderfound',
      meta: {
        title: '确认订单',
      },
      component: () => import("@/view/index/order/found")
    },
    {
      path: '/order/pay',
      name: 'orderpay',
      meta: {
        title: '支付订单',
      },
      component: () => import("@/view/index/order/pay")
    },
    {
      path: '/user',
      name: 'user',
      meta: {
        title: '管理中心',
      },
      component: () => import("@/view/user/index"),
      children:[
        {
          path: 'course',
          name: 'course',
          meta: {
            title: '我的课程',
            icon: 'el-icon-reading'
          },
          component: () => import("@/view/user/children/course/index")
        },
        {
          path: 'datas',
          name: 'datas',
          meta: {
            title: '教学资料',
            icon: 'el-icon-folder-opened'
          },
          component: () => import("@/view/user/children/datas/index")
        },
        {
          path: 'ability',
          name: 'ability',
          meta: {
            title: '能力测试',
            icon: 'el-icon-tickets'
          },
          component: () => import("@/view/user/children/none")
        },
        {
          path: 'wrong',
          name: 'wrong',
          meta: {
            title: '我的错题',
            icon: 'el-icon-document-delete'
          },
          component: () => import("@/view/user/children/none")
        },
        {
          path: 'homework',
          name: 'homework',
          meta: {
            title: '课程进度',
            icon: 'el-icon-document'
          },
          component: () => import("@/view/user/children/none")
        },
        {
          path: 'recharge',
          name: 'recharge',
          meta: {
            title: '学币充值',
            hidden: true,
            icon: 'el-icon-bank-card'
          },
          component: () => import("@/view/user/children/recharge/index")
        },
        {
          path: 'order',
          name: 'order',
          meta: {
            title: '我的订单',
            icon: 'el-icon-document-copy'
          },
          component: () => import("@/view/user/children/order/index")
        },
        {
          path: 'setting',
          name: 'setting',
          meta: {
            title: '个人设置',
            icon: 'el-icon-s-tools',
            hidden: true,
          },
          component: () => import("@/view/user/children/setting/index")
        },
        {
          path: 'points',
          name: 'points',
          meta: {
            title: '我的积分',
            icon: 'el-icon-coin',
            hidden: true
          },
          component: () => import("@/view/user/children/none")
        },
        {
          path: 'trophy',
          name: 'trophy',
          meta: {
            title: '我的奖杯',
            icon: 'el-icon-trophy',
            hidden: true
          },
          component: () => import("@/view/user/children/none")
        },
        {
          path: 'ranking',
          name: 'ranking',
          meta: {
            title: '我的排名',
            icon: 'el-icon-s-marketing',
            hidden: true
          },
          component: () => import("@/view/user/children/none")
        },
        {
          path: 'notice',
          name: 'notice',
          meta: {
            title: '沪声公告',
            icon: 'el-icon-message-solid',
            hidden: true
          },
          component: () => import("@/view/user/children/none")
        },
      ]
    },
    {
      path: '/course/details',
      name: 'courseDetails',
      meta: {
        title: '课程详情',
      },
      component: () => import("@/view/user/children/course/detail")
    },
    {
      path: '/micro/details',
      name: 'microDetails',
      meta: {
        title: '微课详情',
      },
      component: () => import("@/view/user/children/datas/microDetail")
    },
    {
      path: '/micro/video',
      name: 'microVideo',
      meta: {
        title: '微课播放页',
      },
      commomHide: true,
      component: () => import("@/view/user/video/index")
    },
  ],
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if(to.name == 'user'){
    return router.push({path: '/user/course'});
  }
  if (to.name === 'login' && isLogin) {
    router.push({ name: 'index' });
  }
  try {
    const name = to.matched[0].name;
    const nextRoute = ['orderpay', 'orderfound', 'user'];
    const isLogin = auth.getToken()?true : false;  // 是否登录

    // 未登录状态；当路由到nextRoute指定页时，跳转至login
    if (nextRoute.indexOf(name) >= 0) {
      if (!isLogin) {
        if(from.name != 'index') router.push({name: 'index'});
        return Utils.$emit('login');
      }
    }
    next();
  }catch (e) {
    return router.push({name: 'index'});
  }

  // 已登录状态；当路由到login时，跳转首页

});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js